import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { KeyHighlights } from './KeyHighlights';
import { CourseRequirements } from './CourseRequirements';
import { CourseCosts } from './CourseCosts';
import { CertificationFees } from './CertificationFees';
import { RegistrationCallout } from './RegistrationCallout';
import { QuickLinks } from './QuickLinks';
export function RangeSafetyOfficerPage() {
  return <PageLayout data-id="element-3051">
      <HeaderBanner data-id="element-3052" />
      <KeyHighlights data-id="element-3053" />
      <CourseRequirements data-id="element-3054" />
      <CourseCosts data-id="element-3055" />
      <CertificationFees data-id="element-3056" />
      <RegistrationCallout data-id="element-3057" />
      <QuickLinks data-id="element-3058" />
    </PageLayout>;
}